<cx-generic-link url="tel:+49060317930">
  <cx-icon type="PHONE" class="small mr-2"></cx-icon>
  <span>+49 (0) 6031 793 0</span>
</cx-generic-link>
